import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const articleImages = [
  'https://readdy.ai/api/search-image?query=Elegant%20luxury%20lifestyle%20editorial%20photography%20with%20warm%20golden%20and%20dark%20tones%2C%20sophisticated%20atmosphere%2C%20premium%20entertainment%20theme%2C%20soft%20lighting%20with%20rich%20contrast%2C%20high-end%20aesthetic&width=800&height=500&seq=article-bonus-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20golden%20evening%20light%2C%20elegant%20editorial%20photography%20style%2C%20dark%20sophisticated%20undertones%2C%20premium%20sports%20theme%2C%20dramatic%20lighting%20and%20rich%20contrast&width=800&height=500&seq=article-sports-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20casino%20table%20with%20warm%20golden%20lighting%2C%20sophisticated%20dark%20atmosphere%2C%20premium%20entertainment%20setting%2C%20professional%20editorial%20photography%2C%20rich%20contrast%20and%20soft%20shadows&width=800&height=500&seq=article-live-2026&orientation=landscape',
];

export default function ArticleSection() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-secondary-500 tracking-widest uppercase mb-2" style={{ fontFamily: "var(--font-label)" }}>
            最新资讯
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            行业动态与游戏攻略
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            关注必赢亚洲最新资讯，掌握游戏技巧与平台动态
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={articleImages[index]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="text-xs text-secondary-500 font-medium">
                    {article.category === 'sports' ? '体育竞技' : article.category === 'live-casino' ? '真人娱乐' : article.category === 'slots' ? '电子游艺' : '优惠活动'}
                  </span>
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors" style={{ fontFamily: "var(--font-heading)" }}>
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10">
          <Link
            to="/article/welcome-bonus-2026"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary-100 text-secondary-700 font-semibold text-sm hover:bg-secondary-200 transition-all duration-200 whitespace-nowrap"
          >
            阅读更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}